import { BASE_SEO_SET_META, BASE_SEO_RESET_META } from 'rebook/apps/base/constants';


export function setData(payload) {
  return {
    type: BASE_SEO_SET_META,
    payload,
  };
}

export function resetData() {
  return {
    type: BASE_SEO_RESET_META,
  };
}
